import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: (to) => {
      return "/apps";
    }
  },
  {
    path: "/apps",
    name: "apps",
    meta: {
      appFrame: true,
      navBar: false,
      basePath: true
    },
    component: () =>
      import("../views/selectApp.vue"),
  },
  {
    path: "*",
    name: "not-found",
    meta: {
      appFrame: true,
      navBar: true,
    },
    component: () =>
      import("../views/notFound.vue"),
  },
  {
    path: "/profile",
    name: "profile",
    meta: {
      appFrame: true,
      navBar: true,
    },
    component: () =>
      import("../views/Profile.vue"),
  },
  {
    path: "/users",
    name: "users",
    meta: {
      appFrame: true,
      navBar: true,
    },
    component: () =>
      import("../views/Users/users.vue"),
  },
  {
    path: "/login",
    name: "login",
    meta: {
      appFrame: false,
      navBar: false,
    },
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/images",
    name: "images",
    meta: {
      appFrame: true,
      navBar: true
    },
    component: () => import("../views/Player/Images/images.vue"),
  },
  {
    path: "/videos",
    name: "videos",
    meta: {
      appFrame: true,
      navBar: true
    },
    component: () => import("../views/Player/Videos/videos.vue"),
  },
  
  {
    path: "/playlists",
    name: "playlists",
    meta: {
      appFrame: true,
      navBar: true
    },
    component: () => import("../views/Player/Playlists/playlists.vue"),
  },
  {
    path: "/agency",
    name: "agency",
    meta: {
      appFrame: true,
      navBar: true
    },
    component: () => import("../views/Player/Agency/agency.vue"),
  },
  {
    path: "/screens",
    name: "screens",
    meta: {
      appFrame: true,
      navBar: true
    },
    component: () => import("../views/Player/Screens/screens.vue"),
  },
  ///directories pages
  {
    path: "/products",
    name: "products",
    meta: {
      appFrame: true,
      navBar: true
    },
    component: () => import("../views/Directories/Products/products.vue"),
  },
  {
    path: "/characteristics",
    name: "characteristics",
    meta: {
      appFrame: true,
      navBar: true
    },
    component: () => import("../views/Directories/Characteristics/characteristics.vue"),
  },
  {
    path: "/categories",
    name: "categories",
    meta: {
      appFrame: true,
      navBar: true
    },
    component: () => import("../views/Directories/Categories/categories.vue"),
  },
  {
    path: "/directories/banners",
    name: "banners",
    meta: {
      appFrame: true,
      navBar: true
    },
    component: () => import("../views/Directories/Banners/banners.vue"),
  },
  {
    path: "/directories/agencies",
    name: "directories-agencies",
    meta: {
      appFrame: true,
      navBar: true
    },
    component: () => import("../views/Directories/Agency/agency.vue"),
  },
  {
    path: "/directories/screens",
    name: "directories-screens",
    meta: {
      appFrame: true,
      navBar: true
    },
    component: () => import("../views/Directories/Screens/screens.vue"),
  },
  //zones pages
  {
    path: "/zones",
    name: "zones",
    meta: {
      appFrame: true,
      navBar: true
    },
    component: () => import("../views/Zones/Zones.vue"),
  },
  {
    path: "/multizone/screens",
    name: "zones-screens",
    meta: {
      appFrame: true,
      navBar: true
    },
    component: () => import("../views/Zones/Screens/screens.vue"),
  }
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;